import { useTranslation } from 'react-i18next';
import type { OwnFirstConsultationAnswer } from '@/api/ownFirstConsultation/ownFirstConsultationApi.types';
import { CONSULTATION_INTAKE_SECTION_ORDER } from '@/constants/consultationIntakeSections';

interface FirstConsultationOwnViewProps {
  answers: OwnFirstConsultationAnswer[];
  outcome: string | null;
  notes: string | null;
}

export function FirstConsultationOwnView({
  answers,
  outcome,
  notes,
}: FirstConsultationOwnViewProps) {
  const { t } = useTranslation('consultations');
  const isEmpty = answers.length === 0 && outcome === null && notes === null;

  if (isEmpty) {
    return <p className="text-[13px] text-zoomuted">{t('ownerView.empty')}</p>;
  }

  return (
    <div className="space-y-4">
      {CONSULTATION_INTAKE_SECTION_ORDER.map(function renderSection(section) {
        const sectionAnswers = answers.filter(function belongsToSection(answer) {
          return answer.section === section;
        });
        if (sectionAnswers.length === 0) {
          return null;
        }
        return (
          <section key={section}>
            <h3 className="text-[13px] font-bold text-zooindigo mb-2">
              {t('ownerView.section.' + section)}
            </h3>
            <dl className="space-y-2">
              {sectionAnswers.map(function renderAnswer(answer) {
                return (
                  <div key={answer.label}>
                    <dt className="text-[11px] font-semibold text-zoomuted">{answer.label}</dt>
                    <dd className="text-[13px] text-zooindigo whitespace-pre-line">
                      {answer.value}
                    </dd>
                  </div>
                );
              })}
            </dl>
          </section>
        );
      })}
      {outcome === null ? null : (
        <section>
          <h3 className="text-[13px] font-bold text-zooindigo mb-1">
            {t('ownerView.outcomeTitle')}
          </h3>
          <p className="text-[13px] text-zooindigo">{outcome}</p>
        </section>
      )}
      {notes === null ? null : (
        <section>
          <h3 className="text-[13px] font-bold text-zooindigo mb-1">{t('ownerView.notesTitle')}</h3>
          <p className="text-[13px] text-zooindigo whitespace-pre-line">{notes}</p>
        </section>
      )}
    </div>
  );
}
